import { render, staticRenderFns } from "./Fatigue.vue?vue&type=template&id=71916deb&"
import script from "./Fatigue.vue?vue&type=script&lang=js&"
export * from "./Fatigue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports